import { Outlet } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";

const LOGO_IMG = "https://customer-assets.emergentagent.com/job_yarn-weight-pricer/artifacts/6sx1m0su_WhatsApp%20Image%202026-04-13%20at%207.20.45%20PM.jpeg";

export default function ViewerLayout() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    navigate("/view");
    toast.success("Signed out");
  };

  return (
    <div className="min-h-screen bg-background" data-testid="viewer-layout">
      <header className="flex items-center justify-between px-4 sm:px-6 py-3 border-b border-stone-200 bg-white/80 backdrop-blur-xl sticky top-0 z-50">
        <div className="flex items-center gap-3">
          <img src={LOGO_IMG} alt="Logo" className="h-8" />
          <span className="font-heading font-medium text-sm text-foreground">Dhoti Costing Calculator</span>
        </div>
        <Button variant="ghost" size="sm" className="text-stone-500 hover:text-red-600" onClick={handleLogout}>
          <LogOut className="h-4 w-4 mr-2" strokeWidth={1.5} />
          Exit
        </Button>
      </header>
      <main className="p-4 sm:p-6 lg:p-8 max-w-6xl mx-auto">
        <Outlet />
      </main>
    </div>
  );
}
